import { render, staticRenderFns } from "./message-search-popup.html?vue&type=template&id=706d58fa&scoped=true&external"
import script from "./message-search-popup.js?vue&type=script&lang=js&external"
export * from "./message-search-popup.js?vue&type=script&lang=js&external"
import style0 from "./message-search-popup.scss?vue&type=style&index=0&id=706d58fa&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706d58fa",
  null
  
)

export default component.exports